import { InjectionToken } from '@angular/core';

export const STORAGE_KEY = new InjectionToken<string>('storageKey');
